import React from "react";
import "../../Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { officePolicyStatusOptions } from "../../../../constants";

function StatusCheckFilter({ setStatusFilter, seletedStatus }) {
  const handleChange = (e, item) => {
    const status = [...(seletedStatus || [])];
    const idx = status?.findIndex((v) => +item.value === +v);
    if (e.target.checked) {
      status.push(item.value);
    } else if (idx > -1) {
      status.splice(idx, 1);
    }
    setStatusFilter(status);
  };

  return (
    <ul className={["filter-list"]}>
      {officePolicyStatusOptions?.slice(1).map((item) => (
        <li key={item.value}>
          <div className="ch-checkbox">
            <label>
              <input
                type="checkbox"
                onChange={(e) => handleChange(e, item)}
                checked={seletedStatus?.includes(item.value)}
              />{" "}
              <span>{item.label}</span>
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default StatusCheckFilter;
